var $ = require('jquery');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var template = require('./layout-template.hbs');
var HeadingView = require('./heading/view');
var TableView = require('./table/view');
var IndustryPieView = require('./industry-pie/view');
var StartupsLineView = require('./startups-line/view');
var RevenueLineView = require('./revenue-line/view');
var Collection = require('../collection');

module.exports = Marionette.LayoutView.extend({
	template: template,
	tagName: 'div',
  className: 'details-layout',
  regions: {
    heading: '.heading',
    table: '.table',
    'industry-pie': '.industry-pie .box1',
		'startups-line': '.startups-line .line-chart-box',
		//'revenue-line': '.revenue-line .line-chart-box'
  },

	onBeforeRender: function(){
		this.listenTo( UCS.App.MapState,'change:zoomed', this.toggleImpacts);
	},

  onBeforeShow: function() {
		var id = UCS.App.MapState.get('id');
		var object_search_type = UCS.App.MapState.get('type') + '_district_id';
		var county_link = UCS.App.MapState.get('county_link');

		var matchedModels = this.collection.getMatchedAsColl(this.collection, id, object_search_type);
		var matchedModelsActive = new Collection( matchedModels.filter({is_active: true }) );

    this.showChildView('heading', new HeadingView());
    this.showChildView('table', new TableView({
			collection: matchedModelsActive
		}));
		this.showCharts(id, object_search_type, county_link, matchedModels, matchedModelsActive);
  },


	toggleImpacts: function(){
		var zoomed = UCS.App.MapState.get('zoomed');

		if(zoomed){
			$('.details-layout').addClass('full-width');
			$('.details-layout .impact-1, .details-layout .impact-2, .details-layout .impact-3').slideUp();
		}else{
			$('.details-layout').removeClass('full-width');
			$('.details-layout .impact-1, .details-layout .impact-2, .details-layout .impact-3').slideDown();
		}
	},

	showCharts: function(id, object_search_type, county_link, matchedModels, matchedModelsActive){

		this.showChildView('industry-pie', new IndustryPieView({
			collection: matchedModelsActive,
			id: 'industry_pie',
			base_height: 200,
			base_scale: 3000
		}));


		// The following should receive a collection of currently selected area, but All Startups (not just active)
		this.showChildView('startups-line', new StartupsLineView({
			collection: matchedModels,
			base_height: 250,
			base_scale: 3000,
			margin: {
				top: 20,
				right: 40,
				bottom: 20,
				left: 50
			},
			constants: {
				START_YEAR: 1980,
				END_YEAR: 2015
			}
		}));

		// this.showChildView('revenue-line', new RevenueLineView({
		// 	collection: matchedModels,
		// 	base_height: 250,
		// 	base_scale: 3000,
		// 	margin: {
		// 		top: 20,
		// 		right: 40,
		// 		bottom: 20,
		// 		left: 50
		// 	},
		// 	constants: {
		// 		START_YEAR: 1980,
		// 		END_YEAR: 2015
		// 	}
		// }));
	},

	// onDestroy: function(){
	// 	UCS.App.MapState.off('change:matchedModelsColl');
	// }
});
